import React from "react";
import { NewTab } from "../../../../components";
import WorkforceNotifications from "./NotificationCenterTabs/WorkforceNotifications";

const NotificationCenter = () => {
  const tabs = [
    {
      title: "Workforce",
      page: <WorkforceNotifications />,
      type: "main",
    },
  ];
  return (
    <div className="w-full h-full flex flex-col pt-4">
      <NewTab
        tabs={tabs}
        color="black"
        variant="text"
        activeVariant="text"
        tabId="notification-center"
      />
    </div>
  );
};

export default NotificationCenter;
